import { ModuleWithProviders, NgModule } from '@angular/core';
import { ApiModule as AccountingCommonApiModule } from './accounting-common-api';
import { ApiModule as BPMApiModule } from './bpm-utils-api';
import { ApiModule as CommonApiModule } from './common-api';
import { Configuration } from './configuration';
import { ApiModule as FileCenterApiModule } from './file-center-api';
import { ApiModule as RtConsumerApiModule } from './rt-common-api/consumer';
import { ApiModule as RtMerchantApiModule } from './rt-common-api/merchant';
import { ApiModule as NotificationApiModule } from './rt-common-api/notification';
import { ApiModule as RtProductParameterApiModule } from './rt-common-api/product';
import { ApiModule as RtCodeTableApiModule } from './rt-common-api/system-parameter';
import { ApiModule as SystemManagementApiModule } from './system-management-api';
import { ApiModule as ToolLoggerApiModule } from './tool-logger-api';
import { ApiModule as VCifApiModule } from './vcif-api';
let apiUrlConfig: any;

function configurationFactory(url?: string): Configuration {
  return new Configuration({
    basePath: url ?? undefined,
  });
}

const importApiModules = [
  NotificationApiModule.forRoot(() =>
    configurationFactory(
      globalThis.sigv.appContext.envConfig?.apiUrls?.['retailSystemParameter']
    )
  ),
  BPMApiModule.forRoot(() =>
    configurationFactory(
      globalThis.sigv.appContext.envConfig?.apiUrls?.['bpmUtils']
    )
  ),
  FileCenterApiModule.forRoot(() =>
    configurationFactory(
      globalThis.sigv.appContext.envConfig?.apiUrls?.['fileCenter']
    )
  ),
  SystemManagementApiModule.forRoot(() =>
    configurationFactory(
      globalThis.sigv.appContext.envConfig?.apiUrls?.['rbac']
    )
  ),
  ToolLoggerApiModule.forRoot(() =>
    configurationFactory(
      globalThis.sigv.appContext.envConfig?.apiUrls?.['logger']
    )
  ),
  VCifApiModule.forRoot(() =>
    configurationFactory(
      globalThis.sigv.appContext.envConfig?.apiUrls?.['vcif']
    )
  ),
  CommonApiModule.forRoot(() =>
    configurationFactory(
      globalThis.sigv.appContext.envConfig?.apiUrls?.['common']
    )
  ),
  AccountingCommonApiModule.forRoot(() =>
    configurationFactory(
      globalThis.sigv.appContext.envConfig?.apiUrls?.['accountingCommon']
    )
  ),
  RtCodeTableApiModule.forRoot(() =>
    configurationFactory(
      globalThis.sigv.appContext.envConfig?.apiUrls?.['retailSystemParameter']
    )
  ),
  RtMerchantApiModule.forRoot(() =>
    configurationFactory(
      globalThis.sigv.appContext.envConfig?.apiUrls?.['merchant']
    )
  ),
  RtConsumerApiModule.forRoot(() =>
    configurationFactory(
      globalThis.sigv.appContext.envConfig?.apiUrls?.['consumer']
    )
  ),
  RtProductParameterApiModule.forRoot(() =>
    configurationFactory(
      globalThis.sigv.appContext.envConfig?.apiUrls?.['productSetting']
    )
  ),
];

const exportApiModules = [
  CommonApiModule,
  BPMApiModule,
  FileCenterApiModule,
  SystemManagementApiModule,
  ToolLoggerApiModule,
  VCifApiModule,
  AccountingCommonApiModule,
  RtCodeTableApiModule,
  NotificationApiModule,
  RtMerchantApiModule,
  RtConsumerApiModule,
  RtProductParameterApiModule,
];

@NgModule({
  declarations: [],
  imports: [...importApiModules],
  exports: [...exportApiModules],
})
export class CommonExternalApiModule {
  public static forRoot(
    apiConfig: any
  ): ModuleWithProviders<CommonExternalApiModule> {
    apiUrlConfig = apiConfig;
    return {
      ngModule: CommonExternalApiModule,
      providers: [],
    };
  }
}
